import { useTranslation } from "react-i18next";
import React from "react";
import { Footer } from "../../layout/Footer/Footer";

export const PageNotFound: React.FC = () => {
  const { t, i18n } = useTranslation("common");

  return (
    <div className="exception-body error p-2">
      <div className="exception-wrapper">
        <div className="exception-content">
          PageNotFound
          <span>{t("Global_Error")}</span>
        </div>
        <Footer> </Footer>
      </div>
    </div>
  );
};
